export const environment = {
  production: false,
  azureAdClientId: '6c699c1a-72ec-491d-b044-059a0997928c', // cliente Id do Portal Pais SPA
  apiPortalPais: 'https://homologacao.portalpaisapi.virescoerp.com.br',
  apiSaguiControl: 'https://saguicontrolapi-homologacao.azurewebsites.net',
  apiSaguiEdu: 'https://saguieduapi-homologacao.azurewebsites.net',
  // getNetScript: 'https://checkout.getnet.com.br/loader.js?4dtgq0u7nwe',
  getNetScript: 'https://checkout-homologacao.getnet.com.br/loader.js',
  getNetSellerId: 'b485890b-5ca5-4470-a94c-5acdda0ebc41',
  scopes: ['https://saguitechb2c.onmicrosoft.com/8be9481b-b76f-457d-aaba-84fc7a4cd91a/PortalPais.Read'],
  loginUrl: 'https://portalpaishomologacao.virescoerp.com.br/',
};
